export const toFloat = (value: string): number | string => {
    if(!value) return 0
    const parsedValue = parseFloat(value).toFixed(2);
    return parsedValue || 0;
};

export const removeNonNumeric = (str: string) => str?.replace(/[^0-9.]/g, '');

export const removeNonNumericComma = (str: string) => str?.replace(/[^0-9]/g, '');

export const customRound = (number) => {
    const integerPart = Math.floor(number);
    const decimalPart = number - integerPart;

    if (decimalPart >= 0.5) {
        return Math.ceil(number);
    } else {
        return Math.floor(number);
    }
}

export const inputDevider = (value) => {
if(value === "NaN") return ""

    return parseFloat(value.replace(/,/g, '')).toLocaleString();
}

export const removeSpecialChars = (inputString) => {
    return inputString.replace(/[%^$]/g, '');
}